import { getState } from './state';
import { InitializationStatus } from '../../types';
import { createSelector } from 'reselect';
const getInitializationStoreSlice = createSelector([
    getState
], (ncSlice)=>{
    var _ncSlice_initialization;
    return (_ncSlice_initialization = ncSlice.initialization) !== null && _ncSlice_initialization !== void 0 ? _ncSlice_initialization : {};
});
export const getIsReduxInitialized = createSelector([
    getInitializationStoreSlice
], (initSlice)=>initSlice.isReduxInitialized === InitializationStatus.Success);
export const getInitializationStatus = createSelector([
    getInitializationStoreSlice
], (initSlice)=>{
    const initializationStatuses = Object.values(initSlice);
    if (initializationStatuses.length === 0 || initializationStatuses.includes(InitializationStatus.Initializing)) {
        return InitializationStatus.Initializing;
    } else if (initializationStatuses.includes(InitializationStatus.Failure)) {
        return InitializationStatus.Failure;
    }
    return InitializationStatus.Success;
});

//# sourceMappingURL=initialization.js.map